var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.349,
    height: 12.349,
    viewBox: "0 0 12.349 12.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M11.467,7.1H7.5V3.132a.882.882,0,0,0-.882-.882H5.733a.882.882,0,0,0-.882.882V7.1H.882A.882.882,0,0,0,0,7.983v.882a.882.882,0,0,0,.882.882H4.851v3.969a.882.882,0,0,0,.882.882h.882a.882.882,0,0,0,.882-.882V9.747h3.969a.882.882,0,0,0,.882-.882V7.983A.882.882,0,0,0,11.467,7.1Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.851defb190e7799573bbc35a46652bdf.svg";
export { ForwardRef as ReactComponent };